import * as React from 'react';

import { Rows } from '@numbox/components';

type Props = {
  children: React.ReactNode | null | undefined;
};

export const PromptContent = ({ children }: Props) => {
  return (
    <Rows spacing={1} paddingX={2}>
      {children}
    </Rows>
  );
};
